import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import AuthorBlock from '../../components/User/AuthorBlock';
import paths from '../../paths';

export default class ForumSearchItem extends Component {
  static propTypes = {
    item: PropTypes.shape({
      userId: PropTypes.string.isRequired,
      forumCategoriesTitle: PropTypes.string.isRequired,
      forumCategoriesAlias: PropTypes.string.isRequired,
      forumTopicTitle: PropTypes.string.isRequired,
      forumTopicAlias: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      createDate: PropTypes.string.isRequired,
      user: PropTypes.object,
    }).isRequired,
  };

  render() {
    const {
      userId,
      forumCategoriesAlias,
      forumCategoriesTitle,
      forumTopicAlias,
      forumTopicTitle,
      text,
      createDate,
      user,
    } = this.props.item;
    return (
      <div className="theme__post">
        <AuthorBlock
          user={user}
          dateFormat="full"
          createDate={createDate}
          className="theme__post-author -xm"
        />
        <div className="theme__post-content">
          <div className="post-content__theme-path">
            <Link to={`${paths.advocates.forumCategories}/${forumCategoriesAlias}`}>{forumCategoriesTitle}</Link>
            {' / '}
            <Link to={`${paths.advocates.forumTopic}/${forumTopicAlias}`}>{forumTopicTitle}</Link>
          </div>
          <div className="post-content__text" dangerouslySetInnerHTML={{__html: text }}>
          </div>
        </div>
      </div>
    );
  }
}
